import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  distinctUntilChanged,
  map,
  switchMap,
  startWith,
  debounceTime,
} from 'rxjs/operators';
import { AdminService } from '../../../admin/admin.service';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ReportingService } from '../../reporting.service';
import { MatDialog } from '@angular/material/dialog';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';

@Component({
  selector: 'app-bridge-density',
  templateUrl: './bridge-density.component.html',
  styleUrls: ['./bridge-density.component.scss'],
  standalone: false,
})
export class BridgeDensityComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private rptSvc = inject(ReportingService);
  private dialog = inject(MatDialog);

  unitsControl = new FormControl();
  density = { unit: null, score: null };
  filteredUnits;
  selectedUnit;
  bridgeDensityData = { data: null, headers: null };

  ngOnInit(): void {
    this.getUnits();
  }

  getBridgeDensity() {
    this.rptSvc
      .getBridgeDensity(this.density.unit, this.density.score)
      .subscribe({
        next: data => {
          this.bridgeDensityData = { ...data.results };
        },
        error: error => {
          console.error(error);
        },
      });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  exportToExcel(grid: GridComponent): void {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        grid.saveAsExcel();
      }
      dialogRef = null;
    });
  }
}
